export default "__VITE_ASSET__DSsl8znb__"